import React from "react";
import "./AddNewCourt.css";

function updateCourtInputs(input) {
  const container = document.getElementById("court_entries");
  const currentEntries = container.children.length; // Existing number of entries
  const numCourts = parseInt(input.value, 10);

  const warningMessage = document.getElementById("warning_message");

  if (input.value < 1) {
    input.value = "";
    return warningMessage;
  } else {
  }

  // Ensure input is valid
  if (isNaN(numCourts) || numCourts < 1) return;

  // Add new entries if needed
  if (numCourts > currentEntries) {
    for (let i = currentEntries + 1; i <= numCourts; i++) {
      const courtDiv = document.createElement("div");
      courtDiv.className = "court_entry";

      courtDiv.innerHTML = `
        <h3>Court ${i}</h3>
        <div class="court_details">
          <label for="width_${i}">Width (m): </label>
          <input type="number" id="width_${i}" placeholder="Enter width" />

          <label for="length_${i}">Length (m): </label>
          <input type="number" id="length_${i}" placeholder="Enter length" />

          <label for="hourly_cost_${i}">Hourly Cost (£): </label>
          <input type="number" id="hourly_cost_${i}" placeholder="Enter hourly cost" />

          <label for="goals_${i}">Futsal Goals (3x2m)? </label>
          <input type="checkbox" id="goals_${i}" />

          <label for="markings_${i}">Futsal court markings? </label>
          <input type="checkbox" id="markings_${i}" />

          // <label for="spectators_${i}">Space for spectators? </label>
          // <input type="checkbox" id="spectators_${i}" />
        </div>
      `;

      container.appendChild(courtDiv);
    }
  }

  // Remove extra entries if the number is reduced
  if (numCourts < currentEntries) {
    for (let i = currentEntries; i > numCourts; i--) {
      const lastChild = container.lastChild;
      if (lastChild && lastChild instanceof Node) {
        container.removeChild(lastChild);
      }
    }
  }
}

function AddNewCourt() {
  return (
    <div className="form_page">
      <div className="form">
        <h1>Think a court is missing?</h1>
        <p className="form_body">
          Fill in the below form and we'll get it added in no time!
        </p>
        <form>
          <div class="input_box">
            <label for="name">Location Name</label>
            <input type="name" id="name" placeholder="Enter name" required />
          </div>
          <div class="input_box">
            <label for="postcode">Location Postcode</label>
            <input
              type="postcode"
              id="postcode"
              placeholder="Enter postcode"
              required
            />
          </div>
          <div class="input_box">
            <label for="contact">Location Contact Number</label>
            <input
              type="contact"
              id="contact"
              placeholder="Enter contact number"
              required
            />
          </div>
          <div class="input_box" id="futsal_court_input">
            <label for="futsal_courts">Number of Courts</label>
            <input
              type="number"
              id="futsal_courts"
              placeholder="Enter number of Futsal courts"
              required
              min="1"
              step="1"
              onChange={(e) => updateCourtInputs(e.target)}
            />
          </div>
          <div id="court_entries"></div>
          <div class="image_upload">
            <label class="image_upload_label" for="image_upload">Upload an Image of the venue: </label>
            <input
              type="file"
              id="image_upload"
              name="image_upload"
              accept="image/*"
            />
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default AddNewCourt;
